import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedSquareCheckMdFillIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 14, height: 24, viewBox: '0 0 14 24', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M2 5h10c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2m8.531 5.531H10.5c.313-.281.313-.75 0-1.062a.736.736 0 0 0-1.031 0L6 12.969 4.531 11.5c-.312-.312-.781-.312-1.062 0a.684.684 0 0 0 0 1.031l2 2c.281.313.75.313 1.062 0z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '3959aae7c991ca7889bfa5ed7583ea79__a' },
            React.createElement("path", { d: 'M0 0h14v24H0z' })))));
const ForwardRef = forwardRef(LabelPairedSquareCheckMdFillIcon);
export default ForwardRef;
